<script>
import { getObject, setObject } from 'larasnap/support';
import sortBy from 'lodash-es/sortBy';

export default {
    data() {
        return {
            theme: {},
        };
    },
    computed: {
        props() {
            return this.data.props;
        },
        config() {
            return this.data.config;
        },
        rows() {
            return sortBy(this.data.rows, 'order');
        },
        isEmpty() {
            return this.rows.length === 0;
        },
        bus() {
            return this.data.bus;
        },
        totalRows() {
            if (this.props.total_rows) {
                return this.props.total_rows;
            } else {
                return this.rows.length;
            }
        },
    },
    created() {
        const styles = this[`theme_${this.config.theme}`];

        if (!this.$style) {
            this.$style = {};
        }

        if (styles) {
            for (const i in styles) {
                this.$style[i] = styles[i];
            }
        }

        Object.entries(styles).forEach(
            ([name, style]) => (this.theme[name] = style),
        );
    },
    methods: {
        setProps(key, value) {
            setObject(this.data.props, key, value);
        },
        getProps(key) {
            return getObject(this.data.props, key);
        },
        handleError(message) {
            console.error(`SnapGrid Error: ${message}`);
        },
    },
};
</script>
